<template>
  <div class="inspection">
    <a-row :gutter="16" class="inspection-grid">
      <!-- Left Column -->
      <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="column left-column">
        <a-row class="column-content">
          <a-col :span="24" class="module-item" style="height: 30%">
            <DataContainer :title="$t('巡检维保统计')">
              <InspectionAndMaintenance/>
            </DataContainer>
          </a-col>
          <a-col :span="24" class="module-item" style="height: 30%">
            <DataContainer :title="$t('区域巡检排名')">
              <InspectionRegionalRanking/>
            </DataContainer>
          </a-col>
          <a-col :span="24" class="module-item" style="height: 40%">
            <DataContainer :title="$t('保养同期对比')">
              <MaintenancePeriod/>
            </DataContainer>
          </a-col>
        </a-row>
      </a-col>

      <!-- Center Column -->
      <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="column center-column">
        <a-row class="column-content">
          <a-col :span="24" class="module-item" style="height: 60%">
            <DataContainer :title="$t('本月任务')">
              <InspectionCenter/>
            </DataContainer>
          </a-col>
          <a-col :span="24" class="bottom-modules" style="height: 40%">
            <a-row style="height: 100%;">
              <a-col :span="24" style="height: 100%;display: grid;gap: 10px;grid-template-columns: repeat(2, 1fr);">
                <DataContainer :title="$t('巡检同期对比')" >
                  <InspectionPeriod/>
                </DataContainer>
                <DataContainer :title="$t('巡检保养完成率')">
                  <InspectionMaintenanceCompleted/>
                </DataContainer>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>

      <!-- Right Column -->
      <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" class="column right-column">
        <a-row class="column-content">
          <a-col :span="24" class="module-item" style="height: 100%">
            <DataContainer :title="$t('异常状况监控')">
              <InspectionAbnormalCondition/>
            </DataContainer>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import DataContainer from './DataContainer.vue'
import InspectionCenter from './modules/inspection/InspectionCenter.vue'
import InspectionAbnormalCondition from './modules/inspection/InspectionAbnormalCondition.vue'
import InspectionAndMaintenance from './modules/inspection/InspectionAndMaintenance.vue'
import InspectionMaintenanceCompleted from './modules/inspection/InspectionMaintenanceCompleted.vue'
import InspectionPeriod from './modules/inspection/InspectionPeriod.vue'
import InspectionRegionalRanking from './modules/inspection/InspectionRegionalRanking.vue'
import MaintenancePeriod from './modules/inspection/MaintenancePeriod.vue'

export default {
  name: 'Inspection',
  components: {
    DataContainer,
    InspectionCenter,
    InspectionAbnormalCondition,
    InspectionAndMaintenance,
    InspectionMaintenanceCompleted,
    InspectionPeriod,
    InspectionRegionalRanking,
    MaintenancePeriod
  },
  data() {
    return {
      
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.inspection {
  width: 100%;
  height: 100%;
  // padding: 16px;
  overflow: hidden;
  background: transparent;
}

.inspection-grid {
  height: 100%;
  // margin: 0 !important;
}

.column {
  height: 100%;
  // padding: 0 8px;
}

.column-content {
  height: 100%;
  margin: 0 !important;
}

.module-item {
  width: 100%;
}

.bottom-modules {
  width: 100%;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .inspection {
    // padding: 8px;
  }
  
  .column {
    padding: 0 4px;
    margin-bottom: 16px;
  }
  
  .left-column,
  .center-column,
  .right-column {
    height: auto;
  }
}

@media screen and (min-width: 769px) and (max-width: 1200px) {
  .inspection {
    // padding: 12px;
  }
  
  .column {
    padding: 0 6px;
  }
}

/* Enhanced animations and transitions */
.module-item {
  transition: all 0.3s ease;
}

.module-item:hover {
  transform: translateY(-2px);
}

/* Custom scrollbar for better aesthetics */
::v-deep .ant-col::-webkit-scrollbar {
  width: 4px;
}

::v-deep .ant-col::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

::v-deep .ant-col::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

::v-deep .ant-col::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style>